<template>
  <div class="group-manage message-list conmon-top">
    <el-container>
      <!--左侧分组-->
      <el-aside width="220px" class="left-aside-type">
        <div class="group-search">
          <el-input
            placeholder="请输入内容"
            v-model.trim="groupName"
            @keyup.enter.native="searchGroupType">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer" @click="searchGroupType"></i>
          </el-input>
        </div>
        <el-menu
          default-active="0"
          class="el-menu-vertical-demo"
          style="max-height: 850px;width:100%; border-right: none; overflow-y: auto;overflow-x:hidden;margin-bottom: 0;padding-bottom: 0"
          @open="handleOpen"
          @close="handleClose"
          text-color="#333"
          active-text-color="#333">
          <el-menu-item :class="item.choosen ? 'getIt' : ''" :index="index + ''" v-for="(item, index) in groups" :key="index" @click="chooseGroupType(index, item)">
            <div class="menu-btn" v-if="item.name !== '全部'">
              <i v-if="butsObj.edit_group" @click="editGroupTypeItem(item)" class="el-icon-edit" style="margin-right: 0"></i>
              <i v-if="butsObj.del_group" @click="deleteGroupTypeItem(item)" class="el-icon-close" style="margin-right: 0"></i>
            </div>
            <span class="menu-title" :title="item.name">{{ item.name }}</span>
          </el-menu-item>
          <div class="add-group-btn" @click="addGroup" v-if="butsObj.add_group">
            <i class="el-icon-circle-plus-outline" title="添加分组"></i>
          </div>
        </el-menu>
      </el-aside>
      <!--右侧列表-->
      <div style="padding: 0;width: 100%">
        <div class="base-input ovf-hd" style="margin-bottom: 10px">
          <el-row class="search-title">
            <el-col :span="4" class="table-title">
              <i class="el-icon-search" style="font-weight: bold;"></i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col :span="20" class="text-align-right">
              <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide"> {{ hide? '收起查询':'展开查询' }}</el-button>
              <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
              <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
              <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
              <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
            </el-col>
          </el-row>
          <el-row class="search-content common-search-formtype" v-show="hide">
            <el-col :span="24" class="text-align-left">
              <span style="margin-left: 50px">输入搜索：</span>
              <el-input placeholder="短信模板名称" clearable @keyup.enter.native="searchLoad" v-model.trim="searchTmp.sms_name"></el-input>
            </el-col>
          </el-row>
        </div>
        <el-row class="search-title common-table-top" style="padding-right:0;">
          <el-col :span="4" class="table-title">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span>短信列表</span>
          </el-col>
          <el-col :span="20" class="text-align-right safari-input-style">
            <span>移到分组：</span>
            <el-select class="common-search-formtype" style="margin-right: 10px" v-model="group_id" @change="confirmChooseGroupType" :disabled="checkAll" placeholder="请选择目标分组">
              <el-option
                v-for="item in queryGroups"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary" class="add-btn btn-right" style="margin-left:0;cursor:inherit;background: #FF9F00;border-color: #FF9F00">剩余:{{ remainMessage }}条</el-button>
            <!--<el-button type="primary" class="add-btn" :title="showMsg" style="margin-right: 10px;cursor: inherit">联系充值</el-button>-->
            <el-button v-if="butsObj.add" type="primary" class="add-btn list-btn-margin" @click="newMessage">新建</el-button>
            <el-button v-if="butsObj.update_status" type="primary" class="add-btn list-btn-margin" style="margin-left:0;" @click="updateMsgStatus">更新状态</el-button>
          </el-col>
        </el-row>
        <!--短信模板列表-->
        <el-row class="import-data-title table-first-style">
        <el-table v-show="screenWidth >= 1400" v-loading="loading" key="tableData" id="tableData" ref="multipleTable" :data="tableData" class="table table-checkbox-style table-scroll" @selection-change="handleSelectionChange">
          <template slot="empty">
            <div class="newTableEmpty">暂无数据，去<span @click="newMessage">新建</span></div>
          </template>
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="名称">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>{{ scope.row.sms_name }}</p>
                <div slot="reference" class="name-wrapper">
                  {{ scope.row.sms_name }}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="类型" width="100">
            <template slot-scope="scope">
              {{ smsType[scope.row.type] }}
            </template>
          </el-table-column>
          <el-table-column label="内容">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>{{ scope.row.total_content }}</p>
                <div slot="reference" class="name-wrapper" style="max-width: 350px">
                  {{ scope.row.total_content }}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <span v-if="scope.row.check_detail === '' && scope.row.status === 1"><span class="pointGray"></span>短信审核中</span>
                <span v-if="scope.row.check_detail === '' && scope.row.status === 0"><span class="pointGray"></span>草稿</span>
                <span v-if="scope.row.check_detail !== ''">{{ scope.row.check_detail }}</span>
                <span slot="reference" v-if="scope.row.status === 3" class="">
                  <!-- <i class="red-circle"></i> -->
                  <span class="pointRed"></span>{{smsStatus[scope.row.status] }}
                </span>
                <span slot="reference" v-if="scope.row.status === 2" class="">
                  <!-- <i class="green-circle"></i> -->
                  <span class="pointGreen"></span>{{ smsStatus[scope.row.status] }}
                </span>
                <span slot="reference" v-if="scope.row.status === 1 || scope.row.status === 0"><span class="pointGray"></span>{{ smsStatus[scope.row.status] }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <!--<el-table-column label="审核详情" width="">-->
            <!--<template slot-scope="scope">-->
              <!--<span v-if="scope.row.check_detail === '' && scope.row.status === 1">短信审核中</span>-->
              <!--<span v-if="scope.row.check_detail === '' && scope.row.status === 0">草稿</span>-->
              <!--<el-popover trigger="hover" placement="top" v-if="scope.row.check_detail !== ''">-->
                <!--<p>{{ scope.row.check_detail }}</p>-->
                <!--<div slot="reference" class="name-wrapper">-->
                  <!--{{ scope.row.check_detail }}-->
                <!--</div>-->
              <!--</el-popover>-->
            <!--</template>-->
          <!--</el-table-column>-->
          <el-table-column label="创建时间" width="135">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>{{ scope.row.create_time | formatDate }}</p>
                <div slot="reference" class="name-wrapper">
                  {{ scope.row.create_time | formatDate }}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="创建人" width="80">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top" :content="scope.row.username">
                <span class="name-wrapper" slot="reference">{{ scope.row.username }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="send_num" label="群发次数" width="80"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120" style="display: flex;justify-content: center">
            <template slot-scope="scope">
              <div v-if="scope.row.status === 2 && scope.row.type !== 2 && butsObj.send" class="op-link" @click="openSendDialog(scope.row.id, scope.row.template_id, scope.row.content)">
                发送
              </div>
              <div v-if="scope.row.status === 0&&butsObj.edit" class="op-link editColor" @click="openEditMessageDialog(scope.row)">
                编辑
              </div>
              <div v-if="butsObj.del" class="op-link deleteColor" @click="deleteItem(scope.row)">
                删除
              </div>
              <!--<div class="op-link" @click="openTotalDialog(scope.row.id)">-->
                <!--<i class="iconfont icon-icon-tongjixinxi" style="font-size: 14px"></i>-->
                <!--<span>统计</span>-->
              <!--</div>-->
            </template>
          </el-table-column>
        </el-table>
        <!--短信模板小于1200px列表-->
        <el-table v-show="screenWidth < 1400" v-loading="loading" key="tableDatas" id="tableData" ref="multipleTable" :data="tableData" class="table msg-list table-scroll" @selection-change="handleSelectionChange">
          <template slot="empty">
            <div class="newTableEmpty">暂无数据，去<span @click="newMessage">新建</span></div>
          </template>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item class="msg-content" label="内容">
                  <span>{{ props.row.total_content }}</span>
                </el-form-item>
                <el-form-item label="创建时间">
                  <span>{{ props.row.create_time | formatDate }}</span>
                </el-form-item>
                <el-form-item label="创建人">
                  <span>{{ props.row.username }}</span>
                </el-form-item>
                <el-form-item label="群发次数">
                  <span>{{ props.row.send_num }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="名称" width="">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>{{ scope.row.sms_name }}</p>
                <div slot="reference" class="name-wrapper">
                  {{ scope.row.sms_name }}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="类型" width="110">
            <template slot-scope="scope">
              {{ smsType[scope.row.type] }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top" :content="scope.row.username">
                <span v-if="scope.row.check_detail === '' && scope.row.status === 1">短信审核中</span>
                <span v-if="scope.row.check_detail === '' && scope.row.status === 0">草稿</span>
                <span v-if="scope.row.check_detail !== ''">{{ scope.row.check_detail }}</span>
                <span slot="reference" v-if="scope.row.status === 3" class="red">
                    <!--<i class="red-circle"></i>-->
                    {{ smsStatus[scope.row.status] }}</span>
                <span slot="reference" v-if="scope.row.status === 2" class="green">
                    <!--<i class="green-circle"></i>-->
                    {{ smsStatus[scope.row.status] }}</span>
                <span slot="reference" v-if="scope.row.status === 1 || scope.row.status === 0">{{ smsStatus[scope.row.status] }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" style="display: flex;justify-content: center">
            <template slot-scope="scope">
              <div v-if="scope.row.status === 2 && scope.row.type !== 2 &&butsObj.send" class="op-link" @click="openSendDialog(scope.row.id, scope.row.template_id, scope.row.content)">
                发送
              </div>
              <div v-if="scope.row.status === 0&&butsObj.edit" class="op-link editColor" @click="openEditMessageDialog(scope.row)">
                编辑
              </div>
              <div v-if="butsObj.del" class="op-link deleteColor" @click="deleteItem(scope.row)">
                删除
              </div>
              <!--<div class="op-link" @click="openTotalDialog(scope.row.id)">-->
              <!--<i class="iconfont icon-icon-tongjixinxi" style="font-size: 14px"></i>-->
              <!--<span>统计</span>-->
              <!--</div>-->
            </template>
          </el-table-column>
        </el-table>
        <div class="table-foot">
          <el-pagination
            class="table-foot-pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="limit"
            :current-page="page"
            layout="total, prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
        </el-row>
      </div>
    </el-container>

    <!--添加短信分组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="创建短信分组" :visible.sync="adddialog" width="520px">
      <el-form ref="addForm" :model="addForm" :rules="rule">
        <el-form-item label="分组名称:" :label-width="addLabelWidth" prop="name">
          <el-input class="stockInput" type="text" v-model="addForm.name" auto-complete="off" placeholder="输入短信分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="cancelAdd" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="submitForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑短信分组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="编辑短信分组" :visible.sync="editdialog" width="520px">
      <el-form ref="editForm" :model="editForm">
        <el-form-item label="分组名称:" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model="editForm.name" auto-complete="off" placeholder="输入短信分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="confirmEdit">确 定</el-button>
      </div>
    </el-dialog>
    <!--新建短信弹窗-->
    <el-dialog class="cellDialog base-dialog" title="新建短信" :visible.sync="newMessageDialog" width="520px">
      <el-form :rules="rules" ref="newMessageForm" :model="newMessageForm" class="newMessageForm">
        <el-form-item label="短信名称:" :label-width="addLabelWidth" prop="name">
          <el-input  v-model.trim="newMessageForm.name" class="stockInput" type="text"  auto-complete="off" placeholder="输入短信名称"></el-input>
        </el-form-item>
        <el-form-item label="短信签名:" :label-width="addLabelWidth" prop="sign" class="stockInput">
          <el-select filterable v-model="newMessageForm.sign" placeholder="请选择短信签名" class="" prop="sign">
            <el-option
              v-for="item in signs"
              :key="item.id"
              :label="item.sign_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="短信类型:" :label-width="addLabelWidth" class="stockInput" prop="messageType">
          <el-select v-model="newMessageForm.messageType" placeholder="请选择短信类型" class="">
            <el-option
              v-for="item in messageTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="newMessageForm.messageType === 2" label="注册网址:" :label-width="addLabelWidth" style="position: relative" >
          <el-input  v-model.trim="newMessageForm.verify_link" class="stockInput" type="text"  auto-complete="off" placeholder="请输入网站注册页的网址"></el-input>
          <el-tooltip class="item" effect="dark" content="请输入网站注册页的网址, 这样才会被审核通过" placement="bottom">
            <i class="iconfont icon-wenhao remindTips"></i>
          </el-tooltip>
        </el-form-item>
        <!--<el-form-item label="短信内容:" :label-width="addLabelWidth" class="stockInput">-->
          <!--<el-input-->
            <!--type="textarea"-->
            <!--autosize-->
            <!--:rows="2"-->
            <!--@input="httpString"-->
            <!--id="mytextarea"-->
            <!--placeholder="请输入内容"-->
            <!--v-model="newMessageForm.content" maxlength="70">-->
          <!--</el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="短信内容:" :label-width="addLabelWidth" class="stockInput smsContent">
          <div @input="handleInput()" @keyup.8="httpString(newMessageForm.content)" @keyup.46="httpString(newMessageForm.content)" ref="editMessage" contenteditable="true" id="mytextarea"></div>
        </el-form-item>
        <el-form-item label="" :label-width="addLabelWidth" style="margin-top: -20px; margin-bottom: -30px;">
          <span style="cursor: pointer;" :disabled="disabledLink" @click="openInsertDialog" type="primary" class="insert-span">插入链接</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="newMessageDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn save-check-btn" style="margin-right: 32px" type="primary" @click="saveNewMessageAndCheckForm('newMessageForm')">保存并审核</el-button>
        <el-button class="dialog-save-btn" type="primary" @click="saveNewMessageForm('newMessageForm')">保存草稿</el-button>
      </div>
    </el-dialog>
    <!--插入链接弹窗-->
    <el-dialog class="cellDialog base-dialog" title="插入链接" :visible.sync="insertDialog" width="520px">
      <el-form ref="newMessageForm" :model="newMessageForm" class="newMessageForm">
        <el-form-item label="短信链接:" :label-width="addLabelWidth" class="stockInput">
          <template>
            <el-radio-group @change="chooseUrlType" v-model="inputMethods" style="margin-top: 0">
              <el-radio :label="1" style="margin-left: 0;">手动输入链接</el-radio>
              <el-radio :label="2" style="margin-left: 10px;">选择已有链接</el-radio>
              <!--<el-radio :label="3" style="margin-left: 10px;">插入验证码标识</el-radio>-->
            </el-radio-group>
          </template>
        </el-form-item>
        <el-form-item label="" :label-width="addLabelWidth">
          <!--手动输入-->
          <el-input v-if="inputMethods === 1" class="stockInput" type="text" v-model="newMessageForm.link" auto-complete="off" placeholder="输入短信链接"></el-input>
          <!--选取链接-->
          <el-select @change="chooseUrl" v-if="inputMethods === 2" v-model="newMessageForm.link" placeholder="请选择短信链接" class="">
            <el-option
              v-for="item in links"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!--选取验证码-->
          <el-select @change="chooseUrl" v-if="inputMethods === 3" v-model="newMessageForm.link" placeholder="请选择验证码标识" class="">
            <el-option
              v-for="item in verifyLink"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="insertDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="insertUrl">确定</el-button>
      </div>
    </el-dialog>
    <!--编辑短信弹窗-->
    <el-dialog class="cellDialog base-dialog" title="编辑短信" :visible.sync="editNewMessageDialog" width="520px">
      <el-form ref="editNewMessageForm" :model="editNewMessageForm" class="newMessageForm">
        <el-form-item label="短信名称:" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model="editNewMessageForm.name" auto-complete="off" placeholder="输入短信名称"></el-input>
        </el-form-item>
        <el-form-item label="短信签名:" :label-width="addLabelWidth" prop="sign" class="stockInput">
          <el-select filterable disabled v-model="editNewMessageForm.sign" placeholder="请选择短信签名" class="">
            <el-option
              v-for="item in signs"
              :key="item.id"
              :label="item.sign_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="短信类型:" :label-width="addLabelWidth" class="stockInput">
          <el-select disabled v-model="editNewMessageForm.messageType" placeholder="请选择短信类型" class="">
            <el-option
              v-for="item in messageTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="editNewMessageForm.messageType === 2" label="验证链接:" :label-width="addLabelWidth">
          <el-input disabled v-model.trim="editNewMessageForm.verify_link" class="stockInput" type="text"  auto-complete="off" placeholder="输入验证链接"></el-input>
        </el-form-item>
        <el-form-item label="短信内容:" :label-width="addLabelWidth" class="stockInput edit-msg-content">
          <el-input
            type="textarea"
            class="edit-textarea"
            autosize
            :rows="2"
            disabled
            placeholder="请输入短信内容"
            v-model="editNewMessageForm.content">
          </el-input>
        </el-form-item>
        <el-form-item label="" :label-width="addLabelWidth" v-if="isVerify === 1">
          <span @click="openReplaceUrlDialog" class="insert-span" type="primary" style="cursor: pointer;">替换链接</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editNewMessageDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn save-check-btn" style="margin-right: 32px" type="primary" @click="editNewMessageAndCheck">保存并审核</el-button>
        <el-button class="dialog-save-btn" type="primary" @click="editNewMessage">保存草稿</el-button>
      </div>
    </el-dialog>
    <!--替换链接弹窗-->
    <el-dialog class="cellDialog base-dialog" title="替换链接" :visible.sync="replaceUrlDialog" width="520px">
      <el-form ref="editNewMessageForm" :model="editNewMessageForm" class="newMessageForm">
        <el-form-item label="短信链接:" :label-width="addLabelWidth" class="stockInput">
          <template>
            <el-radio-group @change="chooseEditUrlType" v-model="editInputMethods" style="margin-top: 0">
              <el-radio :label="1" style="margin-left: 0;">手动输入链接</el-radio>
              <el-radio :label="2" style="margin-left: 10px;">选择已有链接</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
        <el-form-item label="" :label-width="addLabelWidth">
          <!--手动输入-->
          <el-input @change="editTestLink" v-if="editInputMethods === 1" class="stockInput" type="text" v-model="editNewMessageForm.link" auto-complete="off" placeholder="输入短信链接"></el-input>
          <!--选取链接-->
          <el-select @change="chooseReplaceUrl" v-if="editInputMethods === 2" v-model="editNewMessageForm.link" placeholder="请选择短信链接" class="">
            <el-option
              v-for="item in links"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="replaceUrlDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="replaceUrl">确定</el-button>
      </div>
    </el-dialog>
    <!--发送短信弹窗-->
    <el-dialog class="cellDialog base-dialog" title="发送短信" :visible.sync="sendMessageDialog" width="520px">
      <div class="top-nav">
        <div :class="active ? 'active' : ''" @click="active = true">群发</div>
        <div :class="active ? '' : 'active'" @click="active = false">单发</div>
      </div>
      <el-form v-if="active === true" ref="sendMessageForm" :model="sendMessageForm">
        <el-form-item label="受众类型:" :label-width="addLabelWidth" class="stockInput">
          <el-select v-model="sendMessageForm.model_id" placeholder="请选择受众类型" class="" @change="loadCustomerGroup" >
            <el-option
              v-for="item in cusTypesList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发送群组:" :label-width="addLabelWidth" class="stockInput">
          <el-select v-model="sendMessageForm.queryGroup" placeholder="请选择发送群组" class="">
            <el-option
              v-for="item in targetGroups"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item class="text-align-left" label="发送方式:" :label-width="addLabelWidth">-->
          <!--<template>-->
            <!--<el-radio-group v-model="sendMessageForm.sendType" style="margin-top: 0">-->
              <!--<el-radio :label="1" style="margin-left: 0;">定时发送</el-radio>-->
              <!--<el-radio :label="2" style="margin-left: 10px;">及时发送</el-radio>-->
            <!--</el-radio-group>-->
          <!--</template>-->
        <!--</el-form-item>-->
        <!--<el-form-item v-if="sendMessageForm.sendType === 1" :label-width="addLabelWidth" label="发送时间:" style="margin-top: 20px;">-->
          <!--<el-date-picker v-model="sendMessageForm.send_time" type="datetime" placeholder="请选择发送时间" class="el-date-picker" style="margin-left: 0;width: 280px"></el-date-picker>-->
        <!--</el-form-item>-->
      </el-form>
      <!--单发-->
      <el-form v-if="active === false" ref="sendMessageForm" :model="sendMessageForm">
        <el-form-item label="发送至:" :label-width="addLabelWidth">
          <el-input class="stockInput" type="text" v-model.number="sendMessageForm.target" auto-complete="off" placeholder="输入发送目标手机号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="sendMessageDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="confirmSend">确 定</el-button>
      </div>
    </el-dialog>
    <!--统计弹窗-->
    <el-dialog class="cellDialog" title="短信统计" :visible.sync="totalDialog" width="800px">
      <el-table
        key="totalData"
        id="totalData"
        ref="totalData"
        :data="totalData"
        border
        style="width: 100%"
        class="table">
        <el-table-column
          prop="id"
          label="序号">
        </el-table-column>
        <el-table-column
          label="发送时间">
          <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="发送群组" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.name !== null">{{ scope.row.name}}</span>
            <span v-if="scope.row.name === null">未选群组</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="send_count"
          label="发送数">
        </el-table-column>
        <el-table-column
          prop="click_count"
          label="点击链接"
          width="">
          </el-table-column>
        <el-table-column
          prop="percent"
          label="点击率">
        </el-table-column>
        <el-table-column label="操作" width="" style="display: flex;justify-content: center">
          <template slot-scope="scope">
            <div class="op-link" @click="exportDataAction(scope.row.id)">
              <i class="iconfont icon-icon-dingdanjilu" style="font-size: 14px"></i>
              <span>导出</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination totalPage"
          background
          @size-change="handleSizeChangeTotal"
          @current-change="handleCurrentChangeTotal"
          :page-size="limitTotal"
          :current-page="pageTotal"
          layout="total, prev, pager, next, jumper"
          :total="totalCountTotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCusTypes, getAudGroupList } from '@/api/set.js'
import { butonsList, getMenId } from '@/api/analyse.js'
import { exportSmsStat, getMessageGroupList, getSmsNum, addMessageGroup, deleteMessageGroup, getMessageList, editMessageGroup, loadSigns, deleteMessage, editMessage, addMessage, chooseMessageGroup, getCustomerList, megSendStatistic, getGroupList, sendMessage, updateMsgStatusNow } from '@/api/customer.js'
export default {
  name: 'messageList',
  data () {
    return {
      screenWidth: document.body.clientWidth,
      verifyLink: [
        {
          label: '验证码标识',
          value: '#code#'
        }
      ],
      isVerify: '',
      limitTotal: 10,
      pageTotal: 1,
      totalCountTotal: 0,
      showMsg: '发邮件至xxxxxxxx@qq.com，联系充值',
      loading: false,
      editMsgNeedChange: '',
      editMsgNeedChangeUrl: '',
      insertDialog: false,
      replaceUrlDialog: false,
      inputMethods: 1,
      editInputMethods: 1,
      active: true,
      remainMessage: 520458,
      group_id: '',
      queryGroups: [],
      tableData: [],
      totalData: [],
      customerData: [],
      limit: 10,
      totalCount: 0,
      adddialog: false,
      editdialog: false,
      newMessageDialog: false,
      sendMessageDialog: false,
      editNewMessageDialog: false,
      totalDialog: false,
      addLinkSettingDialog: false,
      value4: '',
      addLinkOptions: [
        {
          label: '百度',
          value: 'www.baidu.com'
        }
      ],
      links: [
        {
          label: '百度',
          value: 'http://www.baidu.com'
        }
      ],
      signs: [],
      smsStatus: {
        0: '草稿',
        1: '审核中',
        2: '审核通过',
        3: '审核失败'
      },
      messageTypes: [
        {
          name: '通知类型',
          id: 0
        },
        {
          name: '营销类型',
          id: 1
        }
      ],
      addForm: {
        name: ''
      },
      editForm: {
        name: ''
      },
      targetGroups: [],
      cusTypesList: [],
      rules: {
        name: [
          { required: true, message: '请输入短信分组名称', trigger: 'blur' }
        ],
        sign: [
          { required: true, message: '请输入短信签名', trigger: 'blur' }
        ],
        messageType: [
          { required: true, message: '请输入短信类型', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入短信内容', trigger: 'blur' }
        ]
      },
      rule: {
        name: [
          { required: true, message: '请输入分组名称', trigger: 'blur' }
        ]
      },
      newMessageForm: {
        name: '',
        sign: '',
        messageType: '',
        link: '',
        verify_link: '',
        content: ''
      },
      realAddSMSContent: '',
      editNewMessageForm: {
        name: '',
        sign: '',
        messageType: '',
        verify_link: '',
        link: '',
        content: ''
      },
      sendMessageForm: {
        model_id: '',
        type: '',
        name: '',
        queryGroup: '',
        target: '',
        sendType: 2,
        send_time: ''
      },
      addLabelWidth: '80px',
      dialogType: 0,
      editId: '',
      editGroupTypeId: '',
      page: 1,
      hide: true,
      closeChoose: '收起筛选',
      searchTmp: {
        sms_name: '',
        group_id: ''
      },
      search: {
        sms_name: '',
        group_id: ''
      },
      groupNameTmp: '',
      groupName: '',
      groups: [],
      deleteArrayIds: [],
      checkAll: true,
      smsType: {
        0: '通知类',
        1: '营销类',
        2: '验证码类'
      },
      groupTypeIndex: 0,
      isDisabled: false,
      editMessageId: '',
      disabledLink: false,
      valueLength: 0,
      position: 0,
      isUrl: false,
      sendId: 0,
      sendTemplateId: 0,
      sendContent: '',
      totalId: '',
      isTest: true,
      testUrl: true,
      butsObj: { // button按钮列表
        add_group: false,
        send:false,
        edit_group: false,
        del_group: false,
        move_to_group: false,
        update_status: false,
        add: false,
        edit: false,
        del: false
      }
    }
  },
  computed: {
    Newitems() {
      let _this = this
      let Newitems = []
      if (_this.groupName === '') {
        return
      }
      _this.groups.map(function(item) {
        if (item.name.search(_this.groupName) != -1) {
          Newitems.push(item)
        }
      })
      return Newitems
    }
  },
  watch: {
    screenWidth (val) {
      if (!this.timer) {
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(function () {
          // that.screenWidth = that.$store.state.canvasWidth
          console.log(that.screenWidth)
          that.init()
          that.timer = false
        }, 400)
      }
    }
  },
  mounted() {
    const that = this
    this.getButtonsList()
    this.getCusTypes()
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
        console.log('that.screenWidth', that.screenWidth)
      })()
    }
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    // 获取受众类型列表
    getCusTypes() {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          this.cusTypesList = res.data.result
          this.sendMessageForm.model_id = res.data.result[0].id
          this.loadCustomerGroup()
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          return false
        }
      })
    },
    searchLoad() {
      this.search = JSON.parse(JSON.stringify(this.searchTmp))
      this.page = 1
      this.load()
    },
    // 统计翻页
    handleSizeChangeTotal(val) {
      this.limitTotal = val
      this.openTotalDialog(this.totalId)
    },
    handleCurrentChangeTotal(pageTotal) {
      this.pageTotal = pageTotal
      this.openTotalDialog(this.totalId)
    },
    // 同步短信状态
    updateMsgStatus() {
      this.loading = true
      updateMsgStatusNow().then((res) => {
        if (res.data.code === 0) {
          this.load()
          _g.toastMsg('success', '更新成功')
          this.loading = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    addLinkAction() {
      this.addLinkSettingDialog = true
    },
    // 打开替换链接弹窗
    openReplaceUrlDialog() {
      this.replaceUrlDialog = true
      this.editNewMessageForm.link = this.editMsgNeedChangeUrl
    },
    // 确认替换链接
    replaceUrl() {
      if (this.editTestLink(this.editNewMessageForm.link) === false) {
        return
      }
      this.editNewMessageForm.content = this.editMsgNeedChange.replace('#url#', this.editNewMessageForm.link)
      this.replaceUrlDialog = false
    },
    // js检测textarea的值有没有url
    httpString(value) {
      if (this.newMessageForm.link !== '') {
        let reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
        value = value.match(reg)
        console.log(value)
        if (value !== null) {
          if (value[0].length < this.valueLength) {
            let tc = document.getElementById('mytextarea')
            let p = tc.getElementsByTagName('p')[0]
            let span = p.getElementsByTagName('span')[0]
            p.removeChild(span)
            this.newMessageForm.content = this.$refs.editMessage.innerText
            this.disabledLink = false
            this.newMessageForm.link = ''
            console.log(this.newMessageForm.link)
          }
        }
        if (value === null) {
          this.disabledLink = false
        }
      }
    },
    // 处理短信内容（插入链接）
    handleInput() {
      this.newMessageForm.content = this.$refs.editMessage.innerText
      console.log('this.newMessageForm.content', this.newMessageForm.content)
    },
    // 插入链接弹窗打开
    openInsertDialog() {
      this.insertDialog = true
      let element = document.getElementById('mytextarea')
      let caretOffset = 0
      let doc = element.ownerDocument || element.document
      let win = doc.defaultView || doc.parentWindow
      let sel
      if (typeof win.getSelection !== 'undefined') {
        sel = win.getSelection()
        if (sel.rangeCount > 0) { // 选中的区域
          let range = win.getSelection().getRangeAt(0)
          let preCaretRange = range.cloneRange()
          preCaretRange.selectNodeContents(element)
          preCaretRange.setEnd(range.endContainer, range.endOffset)
          caretOffset = preCaretRange.toString().length
        }
      } else if ((sel = doc.selection) && sel.type !== 'Control') {
        let textRange = sel.createRange()
        let preCaretTextRange = doc.body.createTextRange()
        preCaretTextRange.moveToElementText(element)
        preCaretTextRange.setEndPoint('EndToEnd', textRange)
        caretOffset = preCaretTextRange.text.length
      }
      this.position = caretOffset
    },
    // 插入链接选择链接
    chooseUrl() {
      if (this.newMessageForm.link !== '') {
        this.isTest = false
      }
    },
    // 替换链接选择连接
    chooseReplaceUrl() {
      if (this.newMessageForm.link !== '') {
        this.testUrl = false
      }
    },
    // 选择连接形式
    chooseUrlType() {
      this.newMessageForm.link = ''
      this.isTest = true
    },
    chooseEditUrlType() {
      this.editNewMessageForm.link = ''
      this.testUrl = true
    },
    // 检测link是否是http和https开头
    testLink(value) {
      let reg = new RegExp('(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&amp;%@!\\-\\/]))?')
      if (!reg.test(value)) {
        _g.toastMsg('error', '请以http://或者https://开头输入网址')
        return false
      } else {
        return true
      }
    },
    editTestLink(value) {
      let reg = new RegExp('(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&amp;%@!\\-\\/]))?')
      if (!reg.test(value)) {
        _g.toastMsg('error', '请以http://或者https://开头输入网址')
        return false
      } else {
        return true
      }
    },
    // 插入链接
    insertUrl() {
      if (this.testLink(this.newMessageForm.link) === false) {
        return
      }
      let tc = document.getElementById('mytextarea')
      let tclen = this.newMessageForm.content.length
      this.$refs.editMessage.innerHTML = '<p>' + this.newMessageForm.content.substr(0, this.position) + '<span>' + this.newMessageForm.link + '</span>' + this.newMessageForm.content.substring(this.position, tclen) + '</p>'
      this.newMessageForm.content = this.newMessageForm.content.substr(0, this.position) + this.newMessageForm.link + this.newMessageForm.content.substring(this.position, tclen)
      this.valueLength = this.newMessageForm.link.length
      this.insertDialog = false
      this.disabledLink = true
    },
    // 打开统计弹窗
    openTotalDialog(id) {
      this.totalDialog = true
      console.log('短信统计res', id)
      this.totalId = id
      megSendStatistic(id, this.limitTotal, this.pageTotal).then(res => {
        this.totalData = res.data.data.list
        this.totalCountTotal = res.data.data.total
        console.log('短信统计res', res)
      })
    },
    // 打开发送弹窗
    openSendDialog(id, template_id, content) {
      this.sendMessageDialog = true
      this.sendId = id
      this.sendTemplateId = template_id
      this.sendContent = content
      this.active = true
      this.sendMessageForm.queryGroup = ''
      this.sendMessageForm.sendType = 2
      this.sendMessageForm.target = ''
    },
    // 确认发送短信
    confirmSend() {
      let send_type = 0
      let query = [this.sendMessageForm.queryGroup]
      let content = JSON.parse(this.sendContent)
      console.log(query)
      if (this.active === true) {
        send_type = 1
        sendMessage(this.sendMessageForm.model_id, this.sendId, query, this.sendTemplateId, content, send_type, '').then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '发送成功')
            this.sendMessageDialog = false
            setTimeout(function () {
              router.push('/home/send-record')
            }, 2000)
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      } else {
        send_type = 2
        sendMessage('', this.sendId, [], this.sendTemplateId, content, send_type, this.sendMessageForm.target).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '发送成功')
            this.sendMessageDialog = false
            setTimeout(function () {
              router.push('/home/send-record')
            }, 2000)
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }
    },
    // 打开新建短信弹窗
    newMessage() {
      this.newMessageDialog = true
      this.newMessageForm.name = ''
      this.newMessageForm.content = ''
      this.newMessageForm.messageType = ''
      this.newMessageForm.sign = ''
    },
    // 打开编辑短信弹窗
    openEditMessageDialog(item) {
      this.editNewMessageDialog = true
      this.editNewMessageForm.name = item.sms_name
      this.editNewMessageForm.messageType = item.type
      this.editNewMessageForm.content = item.editContent
      this.editNewMessageForm.verify_link = item.verify_link
      this.editMsgNeedChange = item.tem_content
      if (item.type === 2) {
        this.editNewMessageForm.content = item.tem_content
        this.isVerify = 0
      } else {
        this.isVerify = 1
        this.editMsgNeedChangeUrl = JSON.parse(item.content).url
      }
      this.editNewMessageForm.sign = item.sign_id
      this.editMessageId = item.id
    },
    // 保存短信草稿
    saveNewMessage() {
      // 如果是验证码
      let queryContent = {}
      if (this.newMessageForm.messageType === 2) {
        this.realAddSMSContent = this.newMessageForm.content
        queryContent.code = ''
        queryContent = JSON.stringify(queryContent)
      } else {
        if (this.newMessageForm.link !== '') {
          this.realAddSMSContent = this.newMessageForm.content.replace(this.newMessageForm.link, '#url# ')
          console.log('01', this.realAddSMSContent, this.newMessageForm.link)
        } else {
          this.realAddSMSContent = this.newMessageForm.content
          console.log('02', this.realAddSMSContent, this.newMessageForm.link)
        }
        queryContent.url = this.newMessageForm.link
        queryContent = JSON.stringify(queryContent)
      }
      addMessage(this.newMessageForm.name, this.newMessageForm.verify_link, this.newMessageForm.messageType, this.realAddSMSContent, 0, this.newMessageForm.sign, queryContent).then((res) => {
        if (res.data.code === 0) {
          this.load()
          _g.toastMsg('success', '添加短信草稿成功')
          this.newMessageDialog = false
          let ele = document.getElementById('mytextarea')
          this.disabledLink = false
          ele.innerText = ''
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 编辑短信草稿
    editNewMessage() {
      let queryContent = {}
      if (this.newMessageForm.messageType === 2) {
        queryContent.code = ''
        queryContent = JSON.stringify(queryContent)
      } else {
        queryContent.url = this.editNewMessageForm.link
        queryContent = JSON.stringify(queryContent)
      }
      editMessage(this.editNewMessageForm.name, this.editNewMessageForm.verify_link, this.editNewMessageForm.messageType, queryContent, 0, this.editNewMessageForm.sign, this.editMessageId, this.editMsgNeedChange).then((res) => {
        if (res.data.code === 0) {
          this.load()
          _g.toastMsg('success', '编辑短信草稿成功')
          this.editNewMessageDialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    saveNewMessageAndCheckForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveNewMessageAndCheck()
        } else {
          return false
        }
      })
    },
    saveNewMessageForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveNewMessage()
        } else {
          return false
        }
      })
    },
    // 保存并审核短信
    saveNewMessageAndCheck() {
      // 如果是验证码
      let queryContent = {}
      if (this.newMessageForm.messageType === 2) {
        this.realAddSMSContent = this.newMessageForm.content
        queryContent.code = ''
        queryContent = JSON.stringify(queryContent)
      } else {
        if (this.newMessageForm.link !== '') {
          this.realAddSMSContent = this.newMessageForm.content.replace(this.newMessageForm.link, '#url# ')
          console.log('01', this.realAddSMSContent, this.newMessageForm.link)
        } else {
          this.realAddSMSContent = this.newMessageForm.content
          console.log('02', this.realAddSMSContent, this.newMessageForm.link)
        }
        queryContent.url = this.newMessageForm.link
        queryContent = JSON.stringify(queryContent)
      }
      addMessage(this.newMessageForm.name, this.newMessageForm.verify_link, this.newMessageForm.messageType, this.realAddSMSContent, 1, this.newMessageForm.sign, queryContent).then((res) => {
        if (res.data.code === 0) {
          this.load()
          _g.toastMsg('success', '添加短信成功,待审核')
          this.newMessageDialog = false
          let ele = document.getElementById('mytextarea')
          this.disabledLink = false
          ele.innerText = ''
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 编辑短信并审核
    editNewMessageAndCheck() {
      let queryContent = {}
      if (this.newMessageForm.messageType === 2) {
        queryContent.code = ''
        queryContent = JSON.stringify(queryContent)
      } else {
        queryContent.url = this.editNewMessageForm.link
        queryContent = JSON.stringify(queryContent)
      }
      editMessage(this.editNewMessageForm.name, this.editNewMessageForm.verify_link, this.editNewMessageForm.messageType, queryContent, 1, this.editNewMessageForm.sign, this.editMessageId, this.editMsgNeedChange).then((res) => {
        if (res.data.code === 0) {
          this.load()
          _g.toastMsg('success', '编辑短信成功,待审核')
          this.editNewMessageDialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 查找群组类型
    searchGroupType() {
      for (let i in this.groups) {
        this.groups[i].choosen = false
        for (let j in this.Newitems) {
          if (this.groups[i].id === this.Newitems[j].id) {
            this.groups[i].choosen = true
          }
        }
      }
    },
    // 点选群组类型
    chooseGroupType(index, item) {
      this.groupTypeIndex = index
      this.search.group_id = item.id
      this.load()
    },
    // 确认移到分组
    confirmChooseGroupType() {
      chooseMessageGroup(this.group_id, this.deleteArrayIds).then((res) => {
        if (res.data.code === 0) {
          this.load()
          _g.toastMsg('success', '移动短信模板至分组成功')
          this.group_id = ''
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 全选
    handleSelectionChange(val) {
      this.deleteArrayIds = []
      for (let i in val) {
        this.deleteArrayIds.push(val[i].id)
      }
      if (parseInt(val.length) > 0) {
        this.checkAll = false
      } else {
        this.checkAll = true
      }
    },
    // 列表删除
    deleteItem(item) {
      this.$confirm('确认删除该短信模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMessage(item.id, item.template_id).then((res) => {
          if (res.data.code === 0) {
            this.load()
            _g.toastMsg('success', '删除短信模板成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange(page) {
      this.page = page
      this.load()
    },
    // 加载短信签名
    loadSignss() {
      loadSigns().then((res) => {
        if (res.data.code === 0) {
          this.signs = res.data.data.list
        }
      })
    },
    // 加载短信模板列表
    load() {
      this.loading = true
      getMessageList(this.page, this.search, 1).then((res) => {
        if (res.data.code === 0) {
          for (let item of res.data.data.list) {
            item.contents = JSON.parse(item.content)
            item.editContent = item.tem_content
            for (let key in item.contents) {
              item.editContent = item.editContent.replace('#' + key + '#', item.contents[key])
            }
          }
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 加载客户群组列表
    loadCustomerGroup() {
      this.sendMessageForm.queryGroup = ''
      getAudGroupList(this.sendMessageForm.model_id, 1, 10000, name, this.search.group_id).then((res) => {
        console.log(res.data, 'qunz')
        if (res.data.code === '200') {
          this.targetGroups = res.data.result.list
        }
      })
    },
    // 添加短信分组
    addGroup() {
      this.adddialog = true
      this.addForm.name = ''
    },
    // 请求短信分组类型数组
    loadGroupType() {
      getMessageGroupList().then((res) => {
        if (res.data.code === 0) {
          res.data.data.list.unshift({ id: '', name: '全部' })
          for (let item of res.data.data.list) {
            item.choosen = false
          }
          this.groups = res.data.data.list
        }
      })
    },
    // 请求短信分组类型数组(给select用)
    loadGroupTypes() {
      getMessageGroupList().then((res) => {
        if (res.data.code === 0) {
          this.queryGroups = res.data.data.list
        }
      })
    },
    // 左侧分组导航
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    // 收起筛选和展开筛选
    closeAndOpen() {
      if (this.hide === true) {
        this.closeChoose = '展开筛选'
        this.hide = false
      } else {
        this.closeChoose = '收起筛选'
        this.hide = true
      }
    },
    // 删除短信分组
    deleteGroupTypeItem(item) {
      this.$confirm('确认删除该短信分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMessageGroup(item.id).then((res) => {
          if (res.data.code === 0) {
            this.loadGroupType()
            _g.toastMsg('success', '删除短信分组成功')
            this.adddialog = false
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 编辑短信分组
    editGroupTypeItem(item) {
      this.editdialog = true
      this.editForm.name = item.name
      this.editGroupTypeId = item.id
    },
    // 确认编辑短信分组
    confirmEdit() {
      editMessageGroup(this.editForm.name, this.editGroupTypeId).then((res) => {
        if (res.data.code === 0) {
          this.loadGroupType()
          _g.toastMsg('success', '编辑短信分组成功')
          this.editdialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 创建短信分组弹窗确定
    confirmAdd() {
      addMessageGroup(this.addForm.name).then((res) => {
        if (res.data.code === 0) {
          this.loadGroupType()
          _g.toastMsg('success', '添加短信分组成功')
          this.adddialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 关闭短信分组弹窗
    cancelAdd() {
      this.adddialog = false
    },
    exportDataAction(id) {
      exportSmsStat(id).then(response => {
        this.download(response)
      }).catch((error) => {
        console.log(error)
        _g.toastMsg('error', '文件不存在')
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 获取短信条数
    loadSmsNum() {
      getSmsNum().then((res) => {
        if (res.data.code === 0) {
          this.remainMessage = res.data.data
        }
      })
    }
  },
  created() {
    this.load()
    this.loadGroupType()
    this.loadGroupTypes()
    this.loadSignss()
    this.loadSmsNum()
  }
}
</script>

<style scoped>
  .table-scroll {
    overflow-x: auto;
  }
  .edit-textarea .el-textarea__inner{
    width: 340px!important;
  }
  .insert-span {
    height: 30px;
    color: #1980FF;
    background: #fff;
    float: right;
    margin-right: 0;
    padding: 3px 0;
  }
  .insertBtn{
    height: 30px;
    color: #1980FF;
    background: #fff;
    float: right;
    margin-right: 0;
    padding: 3px 0;
    border: none;
  }
  .insertBtn:focus,.insertBtn:hover, .insertBtn:active{
    border: none;
    padding: 7px 0;
  }
  /*.green-circle{*/
    /*width: 3px;*/
    /*height: 3px;*/
    /*display: block;*/
    /*background: #05B324;*/
    /*border-radius: 50%;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*margin-top: -1.5px;*/
    /*left: -10px;*/
  /*}*/
  /*.red-circle{*/
    /*width: 3px;*/
    /*height: 3px;*/
    /*display: block;*/
    /*background: #FF2B2B;*/
    /*border-radius: 50%;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*margin-top: -1.5px;*/
    /*left: -10px;*/
  /*}*/
  .remindTips{
    position: absolute;
    right: -10px;
    top: 0;
    font-size: 16px;
    color: #4882ff;
  }
  .el-menu-item .menu-btn{display:none;float:right;}
  .el-menu-item:hover .menu-btn{display: block}
  .name-wrapper{
    -o-text-overflow:ellipsis; /*溢出省略号，支持opera*/
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow: ellipsis;/*超出部分文字以...显示*/
  }
  .red{
    color: #FF2B2B;
    position: relative;
  }
  .green{
    color: #05B324;
    position: relative;
  }
  #mytextarea{
    border: 1px solid #c0c4cc;
    border-radius: 4px;
    line-height: 24px;
    text-align: left;
    min-height: 60px;
    width: 340px;
  }
  .top-nav{
    width: 515px;
    margin-left: -42px;
    margin-top: -20px;
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
    border-bottom: 1px solid #E7E7E7;
    padding-left: 10px;
  }
  .top-nav div{
    width: 60px;
    margin: 0 10px;
    border-bottom: 1px solid #fff;
    cursor: pointer;
  }
  .top-nav .active{
    border-bottom: 2px solid #1980FF;
    color: #1980FF;
  }
  .disabled{
    background: #ccc!important;
  }
  .getIt{
    color: #FF5500!important;
  }
  .cancelCreate{
    float: right;
    margin-right: 10px;
    color: #ff7373;
    cursor: pointer;
  }
  .el-menu-vertical-demo{
    position: relative;
  }
  .group-search{
    height: 60px;
    background: #fff;
    border-bottom: 1px solid #e5e5e5;
  }
  .el-radio-group{
    margin-top: -13px;
  }
  .text-align-left{
    text-align: left;
  }
  .text-align-right{
    text-align: right;
  }
  .table-title{
    text-align: left;
  }
  .save-btn{
    width: 100px;
    display: block;
    height: 30px;
    border-radius: 20px;
    text-align: center;
    line-height: 30px;
    float: right;
    color: #fff;
    font-size: 14px;
    background: #39c6cd;
    margin-top: 5px;
    cursor: pointer;
    border: none;
  }
/*  .search-title{
    background:#ecf6ff;
    border:1px solid #ebebeb;
    height:60px;
    padding:10px;
    line-height: 40px;
  }*/
  ::-webkit-scrollbar
  {
    width: 6px;  /*滚动条宽度*/
    height: 16px;  /*滚动条高度*/
  }
  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;  /*滚动条的背景区域的圆角*/
    background-color: #f5f5f5;/*滚动条的背景颜色*/
  }
  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb
  {
    border-radius: 10px;  /*滚动条的圆角*/
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #ccc;  /*滚动条的背景颜色*/
  }
  .el-form-item__label {
    width: 190px;
  }
</style>
